module.exports = __webpack_public_path__ + "img/PanelInterpretingAcademicInterests.3023e855.jpg";